import { render, staticRenderFns } from "./AlertInfo.vue?vue&type=template&id=bd725eee&scoped=true&"
import script from "./AlertInfo.vue?vue&type=script&lang=js&"
export * from "./AlertInfo.vue?vue&type=script&lang=js&"
import style0 from "./AlertInfo.vue?vue&type=style&index=0&id=bd725eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd725eee",
  null
  
)

export default component.exports